module.exports = __webpack_public_path__ + "static/media/analytics_background.e8a9a4c0.png";